import { render, staticRenderFns } from "./SimpleCV2.html?vue&type=template&id=37ed6fae&scoped=true&external"
import script from "./SimpleCV2.vue?vue&type=script&lang=js"
export * from "./SimpleCV2.vue?vue&type=script&lang=js"
import style0 from "./SimpleCV2.scss?vue&type=style&index=0&id=37ed6fae&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ed6fae",
  null
  
)

export default component.exports